module.exports = __webpack_public_path__ + "img/table-view.afa64ad8.svg";